module.exports = __webpack_public_path__ + "img/markerPink.65262eeb.png";